import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ring from "../../img/icon-ring.png";
import block from "../../img/icon-block.png";
import konvensional from "../../img/icon-konvensional.png";
import digital from "../../img/icon-digital.png";

const Service = () => {
  const serviceRef = useRef(null);
  const [serviceInView, setServiceInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (serviceRef.current) {
        const rect = serviceRef.current.getBoundingClientRect();
        if (rect.top <= window.innerHeight && rect.bottom >= 0) {
          setServiceInView(true);
        } else {
          setServiceInView(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="service">
      <motion.div
        ref={serviceRef}
        className="row d-flex align-items-center"
        initial={{ opacity: 0, y: 50 }}
        animate={serviceInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.75 }}
      >
        <div id="service-service" className="row d-flex align-items-center">
          <div className="col-md-4">
            <div className="row">
              <p>SERVICE</p>
            </div>
            <div className="row">
              <h1>
                <strong>
                  We Provide
                  <br />
                  Awesome
                  <br />
                  Service
                </strong>
              </h1>
            </div>
            <div className="row">
              <p>Servis yang terbaik akan kami berikan kepada anda</p>
            </div>
            <div className="row mb-20">
              <div className="col-2">
                <a href="#block-servise-1">
                  <i className="bi bi-arrow-left-circle" />
                </a>
              </div>
              <div id="panah" className="col-2">
                <a href="#block-servise-4">
                  <i className="bi bi-arrow-right-circle-fill" />
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="scroll-container">
                    <div
                      id="block-servise"
                      className="d-inline-block mx-2 text-center scroll-item"
                    >
                      <div id="block-servise-1" className="row">
                        <div className="col-3" />
                        <div id="img-servise" className="col-6">
                          <img
                            src={ring}
                            className="img-fluid"
                            style={{ maxWidth: "60%" }}
                          />
                        </div>
                        <div className="col-3" />
                      </div>
                      <div className="row">
                        <p>
                          RANTAI
                          <br />
                          PASOK
                        </p>
                      </div>
                      <div id="i-service" className="row">
                        <a href="#block-servise-2">
                          <i className="bi bi-arrow-right-circle-fill" />
                        </a>
                      </div>
                    </div>

                    <div
                      id="block-servise"
                      className="d-inline-block mx-2 text-center scroll-item"
                    >
                      <div id="block-servise-2" className="row">
                        <div className="col-3" />
                        <div id="img-servise" className="col-6">
                          <img
                            src={block}
                            alt=""
                            className="img-fluid"
                            style={{ maxWidth: "60%" }}
                          />
                        </div>
                        <div className="col-3" />
                      </div>
                      <div className="row">
                        <p>
                          TEKNOLOGI
                          <br />
                          BLOCKCHAIN
                        </p>
                      </div>
                      <div id="i-service" className="row">
                        <a href="#block-servise-3">
                          <i className="bi bi-arrow-right-circle-fill " />
                        </a>
                      </div>
                    </div>

                    <div
                      id="block-servise"
                      className="d-inline-block mx-2 text-center scroll-item"
                    >
                      <div id="block-servise-3" className="row">
                        <div className="col-3" />
                        <div id="img-servise" className="col-6">
                          <img
                            src={konvensional}
                            alt=""
                            className="img-fluid"
                            style={{ maxWidth: "60%" }}
                          />
                        </div>
                        <div className="col-3" />
                      </div>
                      <div className="row">
                        <p>
                          METODE
                          <br />
                          KONVENSIONAL
                        </p>
                      </div>
                      <div id="i-service" className="row">
                        <a href="#block-servise-4">
                          <i className="bi bi-arrow-right-circle-fill" />
                        </a>
                      </div>
                    </div>

                    <div
                      id="block-servise"
                      className="d-inline-block mx-2 text-center scroll-item"
                    >
                      <div id="block-servise-4" className="row">
                        <div className="col-3" />
                        <div id="img-servise" className="col-6">
                          <img
                            src={digital}
                            alt=""
                            className="img-fluid"
                            style={{ maxWidth: "60%" }}
                          />
                        </div>
                        <div className="col-3" />
                      </div>
                      <div className="row">
                        <p>
                          METODE
                          <br />
                          DIGITAL
                        </p>
                      </div>
                      <div id="i-service" className="row">
                        <a href="#block-servise-4">
                          <i className="bi bi-arrow-right-circle-fill" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Service;
